const routes = {
  home: '/',
  contactsPage: '/contacts',
  loginPage: '/login',
  registerPage: '/register',
};

export default routes;
